/// <reference path="../../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
declare var select2: any;
namespace Nobox.Nobox {

    @Serenity.Decorators.registerClass()
    export class MergeContactDialog extends NoboxEntityDialog<any, any> {
        protected getFormKey() { return MergeContactForm.formKey; }
        protected form = new MergeContactForm(this.idPrefix);
        public dialogLead: any = null;
        constructor() {
            super();
            var $this = this;
            $('<a class="inplace-button inplace-action4 btn-peek"><b><i class="far fa-eye text-primary"></i></b></a>')
                .attr("title", "See Detail")
                .insertAfter(this.form.Target.element)
                .click(e => {
                    var dlg = new LeadDialog();
                    dlg.loadByIdAndOpenDialog($this.form.Target.value, false);
                });
            $this.form.Target.change(() => {
                var value = $this.form.Target.get_value();
                if (!Q.isEmptyOrNull(value)) {
                    $this.element.find(".btn-peek").show();
                } else {
                    $this.element.find(".btn-peek").hide();
                }
                if (value == $this.dialogLead.get_entityId()) {
                    Q.notifyError("Can't pick same contact");
                    Serenity.EditorUtils.setValue($this.form.Target, "");
                }
            });
        }

        protected updateTitle(): void {
            super.updateTitle();
            this.dialogTitle = "Merge Contact";
        }

        dialogOpen() {
            super.dialogOpen();
            $(".s-Nobox-Nobox-ExcelImportDialog").children("div.ui-dialog-titlebar").find("span.ui-dialog-title").text("Merge Contact");
            Q.Router.replace("");
        }

        getToolbarButtons() {
            return [];
        }

        protected getDialogButtons() {
            var $this = this;
            return [
                {
                    text: 'Merge',
                    cssClass: "bg-primary",
                    click: () => {
                        var action = new MergeLoading();
                        action.done = () => {
                            Q.notifySuccess("Success merge contact");
                            var to = $this.form.Target.value;
                            var dlglead = this.dialogLead;
                            Q.confirm("Delete this contact and open merged contact?", () => {
                                LeadService.Delete({
                                    EntityId: $this.dialogLead.get_entityId()
                                }, () => {
                                    if (this.dialogLead != null) {
                                        this.dialogLead.dialogClose();
                                        var dlg = new LeadDialog();
                                        dlg.loadByIdAndOpenDialog(to);
                                    }
                                })
                            }, {
                                onNo: () => {
                                    new LeadDialog().loadByIdAndOpenDialog(dlglead.get_entityId());
                                    dlglead.dialogClose();
                                }
                            });
                            this.dialogClose();
                        };
                        action.request = {
                            From: $this.dialogLead.get_entityId(),
                            To: $this.form.Target.value as any
                        };
                        action.execute([$this.dialogLead.get_entityId()]);
                        //LeadService.Merge({
                        //    Entity: {
                        //        From: $this.dialogLead.get_entityId(),
                        //        To: $this.form.Target.value as any
                        //    }
                        //}, (res) => {
                        //    Q.notifySuccess("Success merge contact");
                        //    var to = $this.form.Target.value;
                        //    var dlglead = this.dialogLead;
                        //    Q.confirm("Delete this contact and open merged contact?", () => {
                        //        LeadService.Delete({
                        //            EntityId: $this.dialogLead.get_entityId()
                        //        }, () => {
                        //            if (this.dialogLead != null) {
                        //                this.dialogLead.dialogClose();
                        //                var dlg = new LeadDialog();
                        //                dlg.loadByIdAndOpenDialog(to);
                        //            }
                        //        })
                        //    }, {
                        //        onNo: () => {
                        //            new LeadDialog().loadByIdAndOpenDialog(dlglead.get_entityId());
                        //            dlglead.dialogClose();
                        //        }
                        //    });
                        //    this.dialogClose();
                        //}, { blockUI: true })
                    }
                },
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            ] as Serenity.DialogButton[];
        }
    }
}